module.exports = __webpack_public_path__ + "img/KanbanActive.e4d78511.svg";